type Props = React.ImgHTMLAttributes<HTMLImageElement> & {
  variant: "small" | "large";
};

export function Wordmark({ variant, ...rest }: Props) {
  return <img src={`/wordmark-${variant}.webp`} alt="Chorganiser Wordmark" {...rest} />;
}
